import { render, staticRenderFns } from "./LessonElementsContent.vue?vue&type=template&id=0a774642&scoped=true&"
import script from "./LessonElementsContent.vue?vue&type=script&lang=ts&"
export * from "./LessonElementsContent.vue?vue&type=script&lang=ts&"
import style0 from "./LessonElementsContent.vue?vue&type=style&index=0&id=0a774642&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a774642",
  null
  
)

export default component.exports